// Traduce el contexto del dialplan (cdr.dcontext) y el motivo (cdr.userfield) a texto
// legible para los reportes. Los nombres reales NO se renombran en Asterisk: viven en
// los endpoints, en extensions.conf y en todo el historial de CDR. Acá solo se muestran.

export const GRUPOS = ['Saliente', 'Entrante', 'Rechazada', 'Otros'];

const CONTEXTOS = {
  'from-client':       { label: 'Saliente',              grupo: 'Saliente',  ayuda: 'Llamada hecha por un cliente hacia afuera' },
  'from-client-trunk': { label: 'Saliente (troncal IP)', grupo: 'Saliente',  ayuda: 'Llamada saliente desde una troncal corporativa' },
  'from-linkotel':     { label: 'Entrante',              grupo: 'Entrante',  ayuda: 'Llamada recibida del carrier hacia un DID' },
  'bloqueado':         { label: 'Saliente rechazada',    grupo: 'Rechazada', ayuda: 'El ruteo no la cursó (ver motivo)' },
  'default':           { label: 'Tráfico no reconocido', grupo: 'Otros',     ayuda: 'Entró sin contexto válido: posible escaneo' },
  'internal':          { label: 'Interna',               grupo: 'Otros',     ayuda: 'Llamada interna del switch' },
};

export function infoContexto(dcontext) {
  if (!dcontext) return { label: '—', grupo: 'Otros', ayuda: '' };
  if (CONTEXTOS[dcontext]) return CONTEXTOS[dcontext];
  if (dcontext.startsWith('nv-test')) return { label: 'Prueba interna', grupo: 'Otros', ayuda: `Contexto de prueba (${dcontext})` };
  // Un contexto nuevo se muestra crudo para no esconderlo.
  return { label: dcontext, grupo: 'Otros', ayuda: '' };
}

export const etiquetaContexto = d => infoContexto(d).label;
export const grupoContexto    = d => infoContexto(d).grupo;

// userfield = "<motivo>:<detalle>" (lo escribe el dialplan). El de [bloqueado] es
// "bloqueado:<ROUTE_BLOCK_REASON>".
const MOTIVOS = {
  NO_CARRIER:              'Sin ruta para el destino',
  DB_ERROR:                'Error de base de datos',
  ANI_DENIED:              'Número no autorizado para ese destino',
  CATEGORY_DEFAULT_DENIED: 'Destino no permitido por la categoría',
  ANI_SUSPENDED:           'Número suspendido',
  IMPAGO:                  'Cliente suspendido',
  ANON_NO_ENDPOINT:        'Origen no identificado',
  ONNET_NO_DISPONIBLE:     'Número Netvoice no disponible',
  PLAN_NO_ROUTE:           'Destino no incluido en el plan',
  NO_CATEGORY:             'Destino sin categoría',
  BAD_DEST:                'Número de destino inválido',
  FRAUD_BLACKLIST:         'Bloqueado por antifraude',
  cli_ajeno:               'CLI no pertenece a la troncal',
  sin_canales_did:         'Sin canales disponibles en el número',
  corto:                   'Discado corto',
  corto_no_disponible:     'Discado corto no disponible',
  marcado_incompleto:      'Marcado incompleto',
};

export function motivoCdr(userfield) {
  if (!userfield || userfield === 'SYNTH') return '';
  const [tipo, ...resto] = userfield.split(':');
  const detalle = resto.join(':');
  if (tipo === 'bloqueado') return MOTIVOS[detalle] || (detalle ? detalle : 'Bloqueo sin motivo');
  const txt = MOTIVOS[tipo];
  if (!txt) return userfield;
  return detalle ? `${txt} (${detalle})` : txt;
}

// Valor del filtro: "g:<grupo>" filtra por grupo, "c:<dcontext>" por contexto exacto.
export function coincideFiltroContexto(dcontext, filtro) {
  if (!filtro) return true;
  if (filtro.startsWith('g:')) return grupoContexto(dcontext) === filtro.slice(2);
  if (filtro.startsWith('c:')) return dcontext === filtro.slice(2);
  return dcontext === filtro;
}

// Causa de corte de la llamada para el resumen de la página de CDRs. cdr.hangupcause es
// Q.850 (lo graba el dialplan), NO un código SIP; los registros viejos no lo traen y ahí se
// usa el estado del CDR sin inventar un código. Las causas equivalentes van a la misma
// etiqueta (19/18 y NO ANSWER → "No atendida"; 17 y BUSY → "Ocupado").
const Q850 = {
  1:   ['Número inexistente', 'err'],
  3:   ['Sin ruta al destino', 'err'],
  16:  ['Cancelada antes de contestar', 'warn'],  // corte normal sin haber contestado
  17:  ['Ocupado', 'warn'],
  18:  ['No atendida', 'warn'],
  19:  ['No atendida', 'warn'],
  20:  ['Abonado no disponible', 'warn'],
  21:  ['Rechazada por el destino', 'err'],
  27:  ['Destino fuera de servicio', 'err'],
  28:  ['Número incompleto o mal marcado', 'err'],
  31:  ['Corte sin causa específica', 'warn'],
  34:  ['Sin circuito disponible', 'err'],
  38:  ['Red fuera de servicio', 'err'],
  41:  ['Falla temporal', 'err'],
  42:  ['Congestión', 'err'],
  127: ['Error de interconexión', 'err'],
};

export function causaCorte(r) {
  // [bloqueado] contesta para reproducir el aviso: el estado dice ANSWERED y no lo es.
  if (r.dcontext === 'bloqueado') return { label: 'Rechazada por ruteo', tipo: 'err' };
  if (r.disposition === 'ANSWERED') return { label: 'Contestada', tipo: 'ok' };
  const code = parseInt(r.hangupcause, 10);
  if (code && Q850[code]) {
    const [label, tipo] = Q850[code];
    return { label, tipo, code };
  }
  if (code) return { label: `Causa ${code}`, tipo: 'warn', code };
  if (r.disposition === 'NO ANSWER') return { label: 'No atendida', tipo: 'warn' };
  if (r.disposition === 'BUSY')      return { label: 'Ocupado', tipo: 'warn' };
  return { label: 'Falló (sin causa grabada)', tipo: 'err' };
}
